export default __webpack_public_path__ + "static/media/section3@2x.5bddeaec.png";